import Svg from 'components/utilities/svg'

const CollectionIconDense = ({ ...props }) => (
  <Svg viewBox="0 0 22 22" {...props}>
    <title>Collection Icon</title>
    <path d="M1.83337 20.1667V14.6667H7.33337V20.1667H1.83337ZM8.25004 20.1667V14.6667H13.75V20.1667H8.25004ZM14.6667 20.1667V14.6667H20.1667V20.1667H14.6667ZM1.83337 13.7501V8.25007H7.33337V13.7501H1.83337ZM8.25004 13.7501V8.25007H13.75V13.7501H8.25004ZM14.6667 13.7501V8.25007H20.1667V13.7501H14.6667ZM1.83337 7.3334V1.8334H7.33337V7.3334H1.83337ZM8.25004 7.3334V1.8334H13.75V7.3334H8.25004ZM14.6667 7.3334V1.8334H20.1667V7.3334H14.6667Z" />
  </Svg>
)

CollectionIconDense.displayName = 'Collection Dense'

export default CollectionIconDense
